import { EDUCATION_REQUEST_URL, MAIN_REQUEST_URL } from './environments';

export const EDUCATION_API_URL = `${EDUCATION_REQUEST_URL}/`
export const USER_API_URL = `${MAIN_REQUEST_URL}user/api/v2`

export const GLOBAL_REQUEST_ERROR_MESSAGE = 'Beklenmedik bir hata oluştu';

export * from './environments';
export * from './language-options';
export * from './types';
export * from './redux.props'
export * from './role-types'
export * from './component-props'
